var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCPp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 453.54 453.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5e98cf;fill-rule:evenodd;}.cls-2{fill:#044e87;}.cls-3{fill:#0062a2;}.cls-4{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.77,171.8A55,55,0,0,0,179.05,254l95.27-54.85A54.92,54.92,0,0,0,226.77,171.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.37,226.77a110.41,110.41,0,0,1,206-55.25l66.55-38.32a31.77,31.77,0,0,0-12-11.72Q310.5,83.2,244.08,45c-11.92-6.89-23.49-6.64-35.33.34-17.61,10.39-105.81,60.93-132.1,76.15-10.82,6.26-16.09,15.85-16.09,28.32q0,77,0,154A33.23,33.23,0,0,0,64.43,320L131,281.71A109.91,109.91,0,0,1,116.37,226.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.05,254a55,55,0,0,0,95.63-.31l-47.4-27.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.77,337.17A110.34,110.34,0,0,1,131,281.71L64.43,320a31.6,31.6,0,0,0,12.21,12c26.28,15.23,114.49,65.75,132.11,76.15,11.84,7,23.41,7.24,35.34.35q66.36-38.32,132.82-76.51a31.66,31.66,0,0,0,12.2-12l-66.45-38.49A110.37,110.37,0,0,1,226.77,337.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M393,149.8a32.94,32.94,0,0,0-4.06-16.6L227.28,226.27,389.11,320A33.06,33.06,0,0,0,393,303.74S393,201.12,393,149.8Zm-55,83.17H325.29v12.65H312.65V233H300V220.33h12.65V207.68h12.64v12.65h12.65Zm46.14,0H371.44v12.65H358.79V233H346.14V220.33h12.65V207.68h12.65v12.65h12.64Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "371.44 207.68 358.79 207.68 358.79 220.33 346.14 220.33 346.14 232.97 358.79 232.97 358.79 245.62 371.44 245.62 371.44 232.97 384.08 232.97 384.08 220.33 371.44 220.33 371.44 207.68"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "325.3 207.68 312.65 207.68 312.65 220.33 300 220.33 300 232.97 312.65 232.97 312.65 245.62 325.3 245.62 325.3 232.97 337.94 232.97 337.94 220.33 325.3 220.33 325.3 207.68"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M274.68,253.73a55,55,0,1,1-.36-54.54l48.05-27.67a110.39,110.39,0,1,0,.29,110Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCPp);
export default __webpack_public_path__ + "static/media/c_pp.039d512443831fea7df463996c32d48e.svg";
export { ForwardRef as ReactComponent };